module.exports = __webpack_public_path__ + "static/media/eye-slash-grey.88898c4d.svg";